import { computed, EventEmitter, Injectable, signal } from '@angular/core';
import {
  TalentpoolFilterState,
  EMPTY_TALENTPOOL_FILTERS,
} from '../../interfaces/talentpool-filter';

@Injectable({
  providedIn: 'root',
})
export class TalentpoolFilterService {
  readonly filters = signal<TalentpoolFilterState>({ ...EMPTY_TALENTPOOL_FILTERS });
  readonly searchFilterValue = signal<string | null>(null);
  readonly filtersApplied = new EventEmitter<void>();

  readonly hasActiveFilters = computed(() => {
    const current = this.filters();
    return (
      Boolean(current.jobFieldCategorySearch?.trim()) ||
      current.skillFilters.length > 0 ||
      current.languageFilters.length > 0 ||
      Boolean(current.location?.hereId) ||
      current.minYearsExperience != null ||
      Boolean(current.entryDateFrom) ||
      current.kiraFilterChips.length > 0 ||
      Boolean(this.searchFilterValue()?.trim())
    );
  });

  readonly isKiraSearchActive = computed(() =>
    Boolean(this.filters().kiraSearchId),
  );

  patchFilters(partial: Partial<TalentpoolFilterState>): void {
    this.filters.update((current) => ({ ...current, ...partial }));
  }

  /** Replaces the full talent pool filter state in one step. */
  setFilters(state: TalentpoolFilterState): void {
    this.filters.set(state);
  }

  setSearchFilter(value: string | null): void {
    this.searchFilterValue.set(value?.trim() || null);
  }

  resetFilters(): void {
    this.filters.set({ ...EMPTY_TALENTPOOL_FILTERS });
    this.searchFilterValue.set(null);
  }

  notifyFiltersApplied(): void {
    this.filtersApplied.emit();
  }
}
